const localStorageKey = {
    XF_AUTHORIZATION_LG: "xf_Authorization_lg"
}

export default localStorageKey;